import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  
  p {
    cursor: default;
    font-size: 13px;
    color: ${(props) => props.theme.colors.text};
  }
`;

export default { Wrapper };
